class BundleSelector extends HTMLElement {
  constructor() {
    super();
    this.selectElement = null;
    this.isProcessing = false;
  }

  connectedCallback() {
    this.initializeElements();
  }

  initializeElements() {
    this.selectElement = this.querySelector('select.bundle-selector[data-redirect="true"]');
    
    if (this.selectElement) {
      this.selectElement.addEventListener('change', this.handleSelectionChange.bind(this));
    }
  }

  isValidRedirectUrl(url) {
    if (!url || typeof url !== 'string') return false;
    
    try {
      const urlObj = new URL(url, window.location.origin);
      return urlObj.origin === window.location.origin && 
             urlObj.pathname.startsWith('/products/');
    } catch (e) {
      const dangerousPatterns = ['javascript:', 'data:', 'vbscript:', 'about:', 'file:'];
      const lowerUrl = url.toLowerCase();
      
      return url.startsWith('/products/') && 
             !dangerousPatterns.some(pattern => lowerUrl.includes(pattern));
    }
  }

  handleSelectionChange(event) {
    if (this.isProcessing) return;
    
    const selectedUrl = event.target.value;
    
    if (selectedUrl && this.isValidRedirectUrl(selectedUrl)) {
      this.isProcessing = true;
      window.location.href = selectedUrl;
    } else {
      console.warn('Invalid or unsafe URL detected in bundle selector:', selectedUrl);
    }
  }

  disconnectedCallback() {
    if (this.selectElement) {
      this.selectElement.removeEventListener('change', this.handleSelectionChange);
    }
  }
}

customElements.define('bundle-selector', BundleSelector);
